import { getAction } from '@/api/manage'
import { downloadFile } from '@/api/manage'

// 计算列宽度的辅助函数
const getColumnWidth = (element, handleTableHead) => {
  const title = element.alias || element.title || '';
  const limit = handleTableHead ? (handleTableHead(element) || '') : '';
  const unit = element.unitName || '';
  
  const getLen = (str) => {
    if (typeof str !== 'string') return 0;
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) {
        len += 2;
      } else {
        len += 1;
      }
    }
    return len;
  };
  
  const maxLen = Math.max(getLen(title), getLen(limit), getLen(unit));
  // 每个半角字符 7.5px + 24px 左右边距
  const calculatedWidth = Math.ceil(maxLen * 7.5) + 24;
  return Math.min(250, Math.max(110, calculatedWidth));
};

const updateTableScroll = (vm) => {
  if (!vm.columns || vm.columns.length === 0) {
    vm.scroll.x = false;
    vm.cols.forEach((item) => {
      item.fixed = false;
    });
    vm.siteColumn.fixed = false;
    return;
  }

  let totalX = 0;
  vm.columns.forEach((col) => {
    let w = col.width;
    if (col.children && col.children.length > 0) {
      w = col.children[0].width || w;
    }
    if (typeof w === 'string') {
      totalX += parseInt(w, 10) || 100;
    } else if (typeof w === 'number') {
      totalX += w;
    } else {
      totalX += 100;
    }
  });

  // Check if we have table ref and container width
  if (vm.$refs.table && vm.$refs.table.$el) {
    const clientWidth = vm.$refs.table.$el.clientWidth;
    if (totalX <= clientWidth) {
      vm.scroll.x = false;
      vm.columns.forEach((item) => {
        item.fixed = false;
        if (item.children) {
          item.children.forEach((child) => {
            child.fixed = false;
          });
        }
      });
      vm.cols.forEach((item) => {
        item.fixed = false;
      });
      vm.siteColumn.fixed = false;
      return;
    }
  }

  vm.scroll.x = totalX;
  vm.cols.forEach((item) => {
    item.fixed = 'left';
  });
  vm.siteColumn.fixed = 'left';
  vm.columns.forEach((item) => {
    if (item.dataIndex === 'siteName' || item.dataIndex === 'dataTime' || item.code === 'standard') {
      item.fixed = 'left';
    }
  });
};

export const ChangeColMixin = {
  data() {
    return {
      showStandard:true,//排放标准列展示状态
      searchCount: true,
      loadNum: 0,
      popState: false,
      dataDetail: {},
      indeterminate: false,
      checkAll: true,
      //   动态列数组
      options: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 站点列
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        width: '200px',
        title: '站点',
        code:'site_id',
        align: 'center',
        fixed: 'left',
        customRender: (text, record, index) => {
          return record.attrs.siteName
        }
      },
      cols: [
        {
          title: '监测时间',
          align: 'center',
          width: '150px',
          code:'data_time',
          // width:150,
          dataIndex: 'dataTime',
          colName: 'data_time',
          fixed: 'left'
        }
      ],
      scroll: { y: 630 },
      fixedWidth: 250,
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {
        column:'data_time',
        order:'desc'
      },
      /* 数据源 */
      dataSource: [],
      columns: [],
      allColumns: [],
      isPagination: true,
      isReport: false,
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter: {
        // column: 'createTime',
        // order: 'desc',
      },
      /* table加载状态 */
      loading: false
    }
  },
  beforeDestroy() {
    if (document.getElementById('texts')) {
      document.getElementById('texts').remove()
    }
    window.removeEventListener('resize',this.changeCol,false)
  },
  mounted() {
    this.getCol(window.sessionStorage.getItem('siteType'))
    window.addEventListener('setItem', (e) => {
      if (e.key == 'siteType') {
        this.getCol(window.sessionStorage.getItem('siteType'))
      }
    })


    window.addEventListener('resize',this.changeCol,false)
  },
  methods: {
    // 数据状态类型判断  options
    handleOptionsData(){
      return this.siteType == 31 && (window.localStorage.getItem('tenant')==0 || window.localStorage.getItem('tenant')==23)
    },
    handleExportXls(s) {
      let queryParam = JSON.parse(JSON.stringify(this.queryParam))
      this.$refs.colControl?queryParam.factorCodes = this.$refs.colControl.selectCol.join(','):''
      downloadFile(s, this.exportUrl, queryParam)
    },
    //环境标准
    renderStatus2(record) {
      let tag = this.renderStatus3(record)
      if (record.attrs.currentStandard) {

        return (
          <div><span class="statusText" style={'background-color:' + record.attrs.currentStandard.color}>
          {record.attrs.currentStandard.title}
      </span>{tag}</div>
        )
      } else {
        return {tag}
      }
    },
    //环境标准添加达标与否
    renderStatus3(record) {
      if (record.attrs.upStandard) {
        return (
          <span class="statusText" style={'background-color:green;margin-left:5px'}>
          达标
          </span>
        )
      } else {
        if (record.attrs.upStandard === false) {
          return (
            <span class="statusText" style={'background-color:red;margin-left:5px'}>
            不达标
            </span>
          )
        }

      }
    },
    //排放标准
    renderStatus(record) {
      if(record.attrs.msgStatus == 9) {
        return (
          <span class="statusText" style={'background-color:red'}>
          停排
          </span>
        )
      } else {
        if (record.attrs.upStandard) {
          return (
            <span class="statusText" style={'background-color:green'}>
          达标
          </span>
          )
        } else {
          if (record.attrs.upStandard === false) {
            return (
              <span class="statusText" style={'background-color:red'}>
            不达标
            </span>
            )
          }

        }
      }

    },
    // 渲染列
    renderCol(code, text, record, codeTitle) {
      let data = record.factor[code] || { value: '' }
      let status
      let codes
      let title
      if(data.flag){
        if(data.flag.code!='N' && data.flag.code!='T' && data.flag.code!='L'){
          codes = data.flag.code
          title = data.flag.message
        }
      }
      codes?status = <span style='margin-left:5px;' title={title}>{codes}</span>:''
      if (data.status == '2') {
        return (
          <span style='cursor:pointer;' class="redText" onClick={(e)=>this.getDatas(e,data,code,record,codeTitle)}
          title={'原始数据：' + data.raw + '\n' + (data.zsavg ? '折算均值：' + data.zsavg + '\n': '')  +(data.emissionRate ? '排放速率：'+ data.emissionRate  : '')}>
          {data.value}
            {status}
            <a-icon type="arrow-down" style="float:right" />
          </span>
        )
      } else if (data.status == '3') {
        return (
          <span style='cursor:pointer;' class="redText" onClick={(e)=>this.getDatas(e,data,code,record,codeTitle)} title={'原始数据：' + data.raw + '\n' + (data.zsavg ? '折算均值：' + data.zsavg+ '\n' : '')  +(data.emissionRate ? '排放速率：'+ data.emissionRate  : '')}>
          {data.value}
            {status}
            <a-icon type="arrow-up" style="float:right" />
          </span>
        )
      } else {
        return <span style='cursor:pointer;' onClick={(e)=>this.getDatas(e,data,code,record,codeTitle)} title={'原始数据：' + data.raw + '\n' + (data.zsavg ? '折算均值：' + data.zsavg+ '\n' : '')  +(data.emissionRate ? '排放速率：'+ data.emissionRate  : '')}>{data.value}{status}</span>
      }
      // document.getElementById('texts').addEventListener("click",res=>{
      // 	console.log(res)
      // })
    },
    getDatas(e,data,code,record,codeTitle){
      if(document.getElementById('texts')){
        document.getElementById('texts').remove()
      }
      let newDiv = document.createElement("div");
      newDiv.id='texts'
      newDiv.innerHTML=`<div style='background:#f3f1f1;padding:0 2px;border-radius:5px;letter-spacing:1px;border:1px solid #000;position:fixed;z-index:1000;top:${e.pageY+2}px;left:${e.pageX}px;font-size:15px;color:#4a4a4a;display: flex;flex-direction: column'>
      <div>原始数据:${data.raw} ${record['factor'][code] && record['factor'][code].hasOwnProperty('flag') ? record['factor'][code].flag.code  : '' }</div>
      <div>${data.zsavg ? '折算均值：'+ data.zsavg  : ''}</div>
      <div>${data.emissionRate ? '排放速率：'+ data.emissionRate : ''}</div>
</div>`;
      let currentDiv = document.getElementById("app");
      currentDiv.appendChild(newDiv);
      setTimeout(()=>{
        document.getElementById('texts').remove()
      },3000)
      // 小时数据制作弹窗
      if(this.popState){
        this.popUps(code,record,data,codeTitle)
      }
    },
    openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true
      } else {
        this.$refs.colControl.visible = true
      }
    },
    // 是否显示水质标准
    getCol(st,state = true) {
      console.log('enter',st,state)
      if (st.startsWith('2')) {
        this.cols = [
          {
            title: '监测时间',
            align: 'center',
            width: '150px',
            // width:150,
            code:'data_time',
            dataIndex: 'dataTime',
            colName: 'data_time',
            fixed: 'left'
          },
          {
            title: '环境标准',
            align: 'center',
            width: '150px',
            code:'standard',
            // width:150,
            fixed: 'left',
            customRender: (text, record, index) => {
              return this.renderStatus2(record)
            }
          }
        ]
        if(!state){
          this.cols.pop()
        }
      } else if (st.startsWith('3') || st.startsWith('5')) {
        this.cols = [
          {
            title: '监测时间',
            align: 'center',
            width: '150px',
            // width:150,
            dataIndex: 'dataTime',
            colName: 'data_time',
            code:'data_time',
            fixed: 'left'
          },
          {
            title: '排放标准',
            align: 'center',
            width: '100px',
            code:'standard',
            // width:100,
            fixed: 'left',
            customRender: (text, record, index) => {
              return this.renderStatus(record)
            }
          }
        ]
        if(!this.showStandard || !state){
          this.cols.pop()
        }
      } else {
        this.cols = [
          {
            title: '监测时间',
            align: 'center',
            width: '150px',
            code:'data_time',
            dataIndex: 'dataTime',
            colName: 'data_time',
            fixed: 'left'
          }
        ]
      }
    },
    searchQuery() {
      this.loadData(1,true)
    },
    // 动态列变化
    onChange() {
      this.changeCol()
    },
    onTabChange(e){
      if(e==2){
        setTimeout(()=>{
          if(this.$refs.trend && this.$refs.colControl){
            let items=[]
            this.$refs.colControl.selectCol.forEach(item=>{
              this.allColumns.forEach((element) => {
                if (item == element.code) {
                  items.push(element)
                }
              })
            })
            this.$refs.trend.selectCol=[...items]
          }
        },500)

      }
    },
    changeCol() {
      if (!this.columns.every((item) => {
        return item.dataIndex != 'siteName'
      })) {
        this.columns = [...this.cols]
        this.columns.splice(1, 0, this.siteColumn)
        this.$refs.colControl.selectCol.forEach((item, i) => {
          this.allColumns.forEach((element) => {
            if (item == element.code) {
              this.columns.push(element)
            }
          })
        })
      } else {
        this.columns = [...this.cols]
        this.$refs.colControl.selectCol.forEach((item, i) => {
          this.allColumns.forEach((element) => {
            if (item == element.code) {
              this.columns.push(element)
            }
          })
        })
      }
      
      updateTableScroll(this)

      if(this.$refs.trend && this.$refs.colControl){
        let items=[]
        this.$refs.colControl.selectCol.forEach(item=>{
          this.allColumns.forEach((element) => {
            if (item == element.code) {
              items.push(element)
            }
          })
        })
        this.$refs.trend.selectCol=[...items]
      }

    },
    //添加删除列，idx有值代表插入，无值代表删除
    spliceColumn: function(col, idx) {
      //debugger
      let tempColumn = this.columns.filter((item) => item.dataIndex != col.dataIndex) //不允许存在dataIndex相同的列
      if (idx) {
        //插入索引位置
        if (tempColumn.length == this.columns.length) {
          //数组长度一样，说明不存在列，直接添加
          this.columns.splice(idx, 0, col)
        }
      } else {
        if (tempColumn.length != this.columns.length) {
          //数组长度不一样，说明存在列，需要删除
          this.columns = tempColumn
        }
      }
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination
      this.loadData()
    },
    handleTableHead(data){
      if(data.limitsLower!=null&&data.limitsUpper!=null){
        return `(限值区间:${data.limitsLower}~${data.limitsUpper})`
      }else if(data.limitsLower==null&&data.limitsUpper==null){
        return
      }else if(data.limitsLower!=null&&data.limitsUpper==null){
        return `(最低限值:${data.limitsLower})`
      }else if(data.limitsLower==null&&data.limitsUpper!=null){
        return `(最高限值:${data.limitsUpper})`
      }
    },
    // 加载表格
    loadData(arg,updatePage) {
      if(this.queryParam.scope || this.queryParam.scopeId || !this.queryParam.st){
        this.queryParam.st = window.localStorage.getItem('treeSt')
      }
      if (this.isReport && this.queryParam.scope != '1') {
        return
      }
      if (this.isReport) {
        this.queryParam.st = window.sessionStorage.getItem('siteType')
      }
      if (!this.queryParam.st && this.queryParam.scope != '1') {
        this.$message.warning('请选择监测系统类型！')
        return
      }

      if (!this.queryParam.st && this.queryState) {
        this.$message.warning('请选择监测系统类型！')
        return
      }
      this.queryParam.st = window.sessionStorage.getItem('siteType')
      this.loading = true
      let that = this

      if (arg === 1) {
        this.ipagination.current = 1
      }
      if (this.isPagination) {
        this.queryParam.current = this.searchCount ? this.ipagination.current : this.queryParam.current
        this.queryParam.size = this.searchCount ? this.ipagination.pageSize : this.queryParam.size
        this.queryParam.searchCount = this.searchCount
      }
      console.log('JSON.string',JSON.parse(JSON.stringify(this.cols)))
      getAction(this.url, this.queryParam).then((res) => {
        if (res.success) {
          let showStandardState = true
          if (window.sessionStorage.getItem('siteType').startsWith('2')){
            showStandardState = res.result.records.some(item=>{
              if(item.attrs.currentStandard){
                return true
              }else{
                return false
              }
            })
          }
          else if (window.sessionStorage.getItem('siteType').startsWith('3') || window.sessionStorage.getItem('siteType').startsWith('5')){
            showStandardState = res.result.records.some(item=>{
              if(item.attrs.hasOwnProperty('currentStandard')){
                return true
              }else{
                return false
              }
            })
          }

          console.log('showStandardState',showStandardState)
          this.getCol(window.sessionStorage.getItem('siteType'),showStandardState)
          if(!updatePage){
            if(this.queryParam.scope==1){
              if (res.result.query.factors.length+that.cols.length > 0) {
                that.cols.forEach((item) => {
                  item.fixed = 'left'
                })
                that.siteColumn.fixed = 'left'
              } else {
                that.cols.forEach((item) => {
                  item.fixed = false
                })
                that.siteColumn.fixed = false
              }
            }else{
              if (res.result.query.factors.length+that.cols.length > 12) {
                that.cols.forEach((item) => {
                  item.fixed = 'left'
                })
                that.siteColumn.fixed = 'left'
              } else {
                that.cols.forEach((item) => {
                  item.fixed = false
                })
                that.siteColumn.fixed = false
              }
            }

            that.allColumns = [...that.cols]
            that.options = []

          }
          if (that.isPagination) {
            that.dataSource = res.result.records
            that.dataDetail = res.result.query
            that.ipagination.total = res.result.total
            if(!updatePage) {
              res.result.query.factors.forEach((element) => {
                that.options.push({
                  label: element.title,
                  value: element.code,
                  categoryName: element.categoryName
                })
                const colWidth = getColumnWidth(element, that.handleTableHead)
                that.allColumns.push({
                  code: element.code,
                  title: ()=>{return (<span style='width:100%;word-break: break-all;'>{element.title}<br/><span style='color:red'>{this.handleTableHead(element)}</span></span>)},
                  lastTitle:element.title,
                  align: 'center',
                  width: colWidth,
                  children: [
                    {
                      title: element.unitName,
                      align: 'center',
                      width: colWidth,
                      dataIndex: element.code,
                      customRender: (text, record, index) => {
                        return that.renderCol(element.code, text, record, element.title)
                      }
                    }
                  ]
                })
              })
              that.columns = [...that.allColumns]
              if (that.queryParam.scope == '1') {
                that.spliceColumn(that.siteColumn)
                that.fixedWidth = 250
              } else if (that.queryParam.scope == '2' || that.queryParam.scope == '3' || that.queryParam.scope == '4') {
                that.spliceColumn(that.siteColumn, 1)
                if (window.sessionStorage.getItem('siteType').startsWith('2') && that.dataSource.length > 0 && !that.dataSource[0]['attrs']['currentStandard']) {
                  that.fixedWidth = 365
                } else {
                  that.fixedWidth = 450
                }
              }
              if (window.sessionStorage.getItem('siteType').startsWith('2') && that.dataSource.length > 0 && !that.dataSource[0]['attrs']['currentStandard']) {
                for (let i = 0; i < that.columns.length; i++) {
                  if (that.columns[i]['title'] == '环境标准') {
                    that.columns.splice(i, 1)
                    break
                  }
                }
              }
              updateTableScroll(that)
            }
          } else {
            that.dataSource = res.result.records
            that.dataDetail = res.result.query
            if(!updatePage){
              res.result.query.factors.forEach((element) => {
                that.options.push({
                  label: element.alias || element.title,
                  value: element.code,
                  categoryName:element.categoryName
                })
                const colWidth = getColumnWidth(element, that.handleTableHead)
                that.allColumns.push({
                  code: element.code,
                  title: element.alias || element.title,
                  align: 'center',
                  width: colWidth,
                  children: [
                    {
                      title: element.unitName,
                      align: 'center',
                      width: colWidth,
                      dataIndex: element.code,
                      customRender: (text, record, index) => {
                        return that.renderCol(element.code, text, record, element.alias || element.title)
                      }
                    }
                  ]
                })
              })
              that.columns = [...that.allColumns]

              if(!that.queryParam.scope && !that.queryParam.scopeId && that.queryParam.st){
                that.spliceColumn(that.siteColumn, 1)
                that.fixedWidth = 365
                this.scroll.y=580
              }
              updateTableScroll(that)
              // debugger
              // if(!that.queryParam.scope && !that.queryParam.scopeId && that.queryParam.st){
              //   that.scroll.x = that.options.length * 100 + that.fixedWidth
              // }
              this.$forceUpdate()
            }

          }
        } else {
          this.$message.warning('系统异常=>' + res.message)
        }
        if(this.$refs.colControl)this.$refs.colControl.firstState=true
        this.loading = false
        this.loadNum++
      })
    }
  }

}